import React from "react";

import { Container } from "./Container";


export const SectionTitle = (props) => {
  return (
    <Container
      className={` p-8 flex w-full flex-col mt-4 mb-5 ${props.align === "left" ? "" : "items-center justify-center text-center relative"
        }`}>
      {props.preTitle && (
        <div className="text-sm font-bold tracking-wider text-green-500 uppercase">
          {props.preTitle}
        </div>
      )}

      {props.title && (
        <h2 className="max-w-2xl mt-3 text-3xl font-bold leading-snug tracking-tight text-gray-800 lg:leading-tight lg:text-4xl dark:text-white uppercase">
          {props.title}
        </h2>
      )}

      {props.children && (
        <p className="max-w-4xl py-4 text-lg leading-normal text-gray-500 lg:text-xl xl:text-xl dark:text-gray-300">
          {props.children}
        </p>
      )}
    </Container>
  );
}

